import React, { FC } from 'react';

import styled from 'styled-components';

import AgeCategorySelector from '../common/AgeCategorySelector';
import LanguageNavigationDropdown from '../../shop/language/navigation/LanguageNavigationDropdown';
import LanguageDropDown from '../../shop/language/navigation/LanguageDropDown';
import LoanFormatDropDown from './LoanFormatDropDown';
import SubNavigationLayout from './SubNavigationLayout';
import { AppDispatch } from '../../store';
import { LoanFormatState } from '../../store/loanFormat/state';
import { useRouteMatch } from 'react-router';

const StAgeCategorySelector = styled(AgeCategorySelector)`
    margin-left: 10px;
`;

const StForeignLanguageNavigationDropdown = styled(LanguageNavigationDropdown)`
    margin-right: 10px;
`;

const StDropDownContainer = styled.div`
    display: flex;
`;

type Props = {
    readonly loanFormat: LoanFormatState;
    readonly languages: ReadonlyArray<{ readonly name: string; readonly count: number }>;
    readonly selectedLanguage: string | null;
    readonly isInLanguageLearning?: boolean;
    readonly hideGenres?: boolean;
    readonly isSticky?: boolean;
    readonly dispatch: AppDispatch;
};

const ForeignLanguageSubNavigation: FC<Props> = ({ languages, isInLanguageLearning, isSticky }) => {
    const match = useRouteMatch<{ section: string; languageId: string; page: string; loanFormat: string }>(
        '/language/:section/:languageId/:page/:loanFormat'
    );

    return (
        <SubNavigationLayout
            left={
                <StDropDownContainer>
                    <StForeignLanguageNavigationDropdown isInLanguageLearning={isInLanguageLearning} />
                    {match?.params.languageId && (
                        <LanguageDropDown languages={languages} selectedLanguage={match?.params.languageId ?? ''} />
                    )}
                </StDropDownContainer>
            }
            // PORTAL-3993 nav items are currently not shown
            right={
                !isSticky && (
                    <StDropDownContainer>
                        <LoanFormatDropDown showIcons={false} />
                        <StAgeCategorySelector />
                    </StDropDownContainer>
                )
            }
            isSticky={isSticky}
            width="35"
        />
    );
};

export default ForeignLanguageSubNavigation;
